import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Switch,
  Avatar,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";



//Icons
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../Style/pagestyle.scss";
import FooterPagination from "../Components/Include/FooterPagination";
import LoadingPage from "../Components/Include/LoadingPage";
import { GET_SIZE_PAGINATION, UPADATE_SIZE_IS_USE } from "../Schema/Size";
import EmptyData from "../Components/Include/EmptyData";
import CreateIcon from "../Assets/create-icon.svg";
import CreateSize from "../Components/Size/CreateSize";
import SizeAction from "../Components/Size/SizeAction";
import { AuthContext } from "../Context/AuthContext";

export default function Size() {
  const { setAlert } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // Switch
  const [status, setStatus] = useState("All");

  const { refetch } = useQuery(GET_SIZE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
      isUse: status === "All" ? null : status,
    },
    onCompleted: ({ getSizePagination }) => {
      setTableData(getSizePagination?.data);
      setPaginationData(getSizePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLoading(true);
    setLimit(e.target.value);
    setPage(1);
  };

  const [updateSizeIsUse] = useMutation(UPADATE_SIZE_IS_USE, {
    onCompleted: ({ updateSizeIsUse }) => {
      if (updateSizeIsUse?.status) {
        setAlert(true, "success", updateSizeIsUse?.message);
      } else {
        setAlert(true, "error", updateSizeIsUse?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateSizeIsUse({
      variables: {
        id: id,
        isUse: status,
      },
    });
  };

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">ការកំណត់</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ទំហំ</Typography>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្វែងរក</Typography>
            <TextField
              placeholder="ស្វែងរកឈ្មោះអ្នកប្រើប្រាស់"
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={4} lg={3} xl={2.4}>
            <Typography className="header-text">ស្ថានភាព</Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="All">ទាំងអស់</MenuItem>
                <MenuItem value={true}>ប្រើប្រាស់</MenuItem>
                <MenuItem value={false}>មិនប្រើប្រាស់</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={6} xl={7.2}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                បង្កើត
              </Button>
            </Stack>
            <CreateSize
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start" width="10%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="15%">
                ទំហំជាភាសាខ្មែរ
              </TableCell>
              <TableCell className="header-title" width="15%">
                ទំហំជាអង់គ្លេស
              </TableCell>
              <TableCell className="header-title" width="20%">
                Remark
              </TableCell>
              <TableCell className="header-title" align="center" width="10%">
                Status
              </TableCell>

              <TableCell className="header-title-end" width="30%"></TableCell>
            </TableHead>

            {loading ? (
              <LoadingPage colSpan={6} />
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <EmptyData colSpan={6} />
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start">
                            {index + paginationData?.slNo}
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.sizeKhName}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.sizeEnName}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell">
                            <Typography className="member-name">
                              {row?.remark}
                            </Typography>
                          </TableCell>
                          <TableCell className="body-cell" align="center">
                            <Box>
                              <Switch
                                checked={row?.isUse}
                                onChange={() =>
                                  handleUpdateStatus(row?._id, !row?.isUse)
                                }
                              />
                            </Box>
                          </TableCell>
                          <TableCell className="body-cell-end" align="right">
                            <SizeAction editData={row} setRefetch={refetch} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
